import { useEdit } from '@zoryn/components/grid/src/methods/edit'
import { useFooter } from '@zoryn/components/grid/src/methods/footer'
import { attachGridColumnWidthMethods } from '@zoryn/components/grid/src/methods/column-width'
import { useContextMenu } from '@zoryn/components/grid/src/methods/row-context-menu'
import { useQuery } from './query'
import { useTreeExpand } from './tree-expand'
import { useRow } from './row'
import { useToolbar } from './toolbar'
import type { DataGridTree } from '../types'

export function attachGridTreeMethods($grid: DataGridTree) {
  useQuery($grid)
  useRow($grid)
  useTreeExpand($grid)
  useToolbar($grid)
  useEdit($grid as never)
  useFooter($grid as never)
  useContextMenu($grid as never)
  attachGridColumnWidthMethods($grid as never)
}
